import {NuxtIcon} from "#components";
import {h} from "vue";
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 25"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#393d46",
      "fill-rule": "evenodd",
      d: "M15 5.5H2.5v-1H16v1h4.338l.126.314 1.976 4.939L23.9 12.7l.1.133V19h-2.67a3.001 3.001 0 0 1-5.66 0h-5.34a3.001 3.001 0 0 1-5.66 0H2v-1h2.5a3 3 0 1 1 6 0h5a3 3 0 1 1 6 0H23v-4.833L21.75 11.5H15v-6m1 5h5.262l-1.6-4H16zm-14.5-3h7v1h-7zm-1.5 3h7v1H0zm1.5 3h4v1h-4zm6 6.5a2 2 0 1 0 0-4 2 2 0 0 0 0 4m11 0a2 2 0 1 0 0-4 2 2 0 0 0 0 4",
      "clip-rule": "evenodd"
    }, null, -1)
  ]))]))
}
export default { render() { return h(NuxtIcon, {icon: {render}, name: "shipment"}) } }